var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-comment-container"},[_c('MessageArea',{attrs:{"title":"评论列表","subTitle":`(${_vm.datas.total||_vm.total})`,"list":_vm.list,"listLoading":_vm.loading},on:{"handleSubmit":_vm.handleSubmit}}),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"loading"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }